-<template>

<!--visualization for journey or Collection-->
  <v-container v-if="isMap==true&&isJourneyVisualization==true" @click="openSingleStoryDetail(singleStory.id)" class="px-0 mx-0">

    <v-img v-if="singleStory.cover_image.media.formats==null||typeof singleStory.cover_image.media.formats=='undefined'" class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>

    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.coverImageCenter" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.coverImageCenter.hash + singleStory.cover_image.media.formats.coverImageCenter.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.small" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.small.hash + singleStory.cover_image.media.formats.small.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.thumbnail" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.thumbnail.hash + singleStory.cover_image.media.formats.thumbnail.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <v-img v-else class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>

    <v-row class=" pt-0 pb-0 mx-0 px-0 complementaryVariant">
      <v-col style="word-break:break-all;font-size:1.2rem" cols="12"
        class="mx-0 px-2 mt-0 mb-0 pt-2 pb-0 font-weight-black">
        <span class="titlePreviewFontStyle"
          :title="singleStory.title">{{truncateTitleMap(singleStory.title,20,20)}}</span>
      </v-col>
    </v-row>
    <v-row class=" pt-2 pb-2 mx-0 px-2 complementaryVariant">
      <v-col v-if="singleStory.user" style="word-break: break-all;" cols="6"
        class="is_draftPreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 ">
        <div v-if="singleStory.user.id!=getUser.id">
          <span class="authorPreviewFontStyle">{{singleStory.user.username}}</span>
        </div>
        <div v-else>
          <span v-if="!isDraft">{{$t("published")}} </span>
          <span v-else>{{$t("savedAsDraft")}}</span>
        </div>
      </v-col>
      <v-col style="word-break: break-all;" cols="6"
        class="datePreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 text-right">
        <span>{{singleStory.created_at | moment("DD/MM/YYYY")}}</span>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else-if="(isMapIframe==true&&isMap==true)" class="px-0 mx-0">

    <v-img v-if="singleStory.cover_image.media.formats==null||typeof singleStory.cover_image.media.formats=='undefined'" class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>

    <mediaFileStory v-if="singleStory.cover_image.media.formats.coverImageCenter" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.coverImageCenter.hash + singleStory.cover_image.media.formats.coverImageCenter.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.small" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.small.hash + singleStory.cover_image.media.formats.small.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.thumbnail" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.thumbnail.hash + singleStory.cover_image.media.formats.thumbnail.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />

    <v-row class=" pt-0 pb-0 mx-0 px-0 complementaryVariant">
      <v-col style="word-break:break-all;font-size:1.2rem" cols="12"
        class="mx-0 px-2 mt-0 mb-0 pt-2 pb-0 font-weight-black">
        <span class="titlePreviewFontStyle"
          :title="singleStory.title">{{truncateTitleMap(singleStory.title,20,20)}}</span>
      </v-col>
    </v-row>
    <v-row class=" pt-2 pb-2 mx-0 px-2 complementaryVariant">
      <v-col v-if="singleStory.user" style="word-break: break-all;" cols="6"
        class="is_draftPreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 ">
        <div v-if="singleStory.user.id!=getUser.id">
          <span class="authorPreviewFontStyle">{{singleStory.user.username}}</span>
        </div>
        <div v-else>
          <span v-if="!isDraft">{{$t("published")}} </span>
          <span v-else>{{$t("savedAsDraft")}}</span>
        </div>
      </v-col>
      <v-col style="word-break: break-all;" cols="6"
        class="datePreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 text-right">
        <span>{{singleStory.created_at | moment("DD/MM/YYYY")}}</span>
      </v-col>
    </v-row>
  </v-container>

  <v-container v-else-if="isMap==true" @click="openSingleStoryDetail(singleStory.id)" class="px-0 mx-0">

    <v-img v-if="singleStory.cover_image.media.formats==null||typeof singleStory.cover_image.media.formats=='undefined'" class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>

    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.coverImageCenter" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.coverImageCenter.hash + singleStory.cover_image.media.formats.coverImageCenter.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.small" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.small.hash + singleStory.cover_image.media.formats.small.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.thumbnail" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.thumbnail.hash + singleStory.cover_image.media.formats.thumbnail.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <v-img v-else class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>

    <v-row class=" pt-0 pb-0 mx-0 px-0 complementaryVariant">
      <v-col style="word-break:break-all;font-size:1.2rem" cols="12"
        class="mx-0 px-2 mt-0 mb-0 pt-2 pb-0 font-weight-black">
        <span class="titlePreviewFontStyle"
          :title="singleStory.title">{{truncateTitleMap(singleStory.title,20,20)}}</span>
      </v-col>
    </v-row>
    <v-row class=" pt-2 pb-2 mx-0 px-2 complementaryVariant">
      <v-col v-if="singleStory.user" style="word-break: break-all;" cols="6"
        class="is_draftPreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 ">
        <div v-if="singleStory.user.id!=getUser.id">
          <span class="authorPreviewFontStyle">{{singleStory.user.username}}</span>
        </div>
        <div v-else>
          <span v-if="!isDraft">{{$t("published")}} </span>
          <span v-else>{{$t("savedAsDraft")}}</span>
        </div>
      </v-col>
      <v-col style="word-break: break-all;" cols="6"
        class="datePreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 text-right">
        <span>{{singleStory.created_at | moment("DD/MM/YYYY")}}</span>
      </v-col>
    </v-row>
  </v-container>



  <v-container v-else @click="openSingleStoryDetail(singleStory.id)">
    <v-img v-if="singleStory.cover_image.media.formats==null||typeof singleStory.cover_image.media.formats=='undefined'" class="coverImageStyle" :src="require('@/assets/placeholder.png')"></v-img>

    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.small" class="coverImageStyle"
      :mediaUrl="typeof singleStory.cover_image.media.formats.coverImageCenter!='undefined' ? apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.coverImageCenter.hash + singleStory.cover_image.media.formats.coverImageCenter.ext : apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.small.hash + singleStory.cover_image.media.formats.small.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />
    <mediaFileStory v-else-if="singleStory.cover_image.media.formats.thumbnail" class="coverImageStyle"
      :mediaUrl=" apiStrapi +'/uploads/'+ singleStory.cover_image.media.formats.thumbnail.hash + singleStory.cover_image.media.formats.thumbnail.ext"
      :type="singleStory.cover_image.type" :isLocal="false" :isThumbnail="true" />

    <v-row class=" pt-2 pb-2 mx-0 px-2 complementaryVariant">
      <v-col style="word-break:break-all;font-size:1.2rem" cols="12"
        class="mx-0 px-0 mt-0 mb-0 pt-2 pb-0 font-weight-black">
        <span class="titlePreviewFontStyle" :title="singleStory.title">{{truncate(singleStory.title,16,36)}}</span>
      </v-col>
    </v-row>
    <v-row class=" pt-2 pb-2 mx-0 px-2 complementaryVariant">
      <v-col v-if="singleStory.user" style="word-break: break-all;" cols="6"
        class="is_draftPreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 ">
        <div v-if="singleStory.user.id!=getUser.id">
          <span class="authorPreviewFontStyle">{{singleStory.user.username}}</span>
        </div>
        <div v-else>
          <span v-if="!isDraft">{{$t("published")}} </span>
          <span v-else>{{$t("savedAsDraft")}}</span>
        </div>
      </v-col>
      <v-col style="word-break: break-all;" cols="6"
        class="datePreviewfontStyle mx-0 px-0 mt-0 mb-0 pt-0 pb-0 text-right">
        <span>{{singleStory.created_at | moment("DD/MM/YYYY")}}</span>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import mediaFileStory from "@/components/mediaFileStory.vue";

export default {
  name:'storiesPreviewHome',

   data () {
      return {
          apiStrapi: process.env.VUE_APP_ROOT_STRAPI,
      }
    },
    mounted(){

      //this.orderedAllStories = this.allStories.slice(this.counter).concat(this.allStories.slice(0,this.counter))
      // i have to create a list of stories where the first one is the one selected to heve an array to iterate
    },
    methods: {
        calcoulateBackgroundColor(journeyColorBackground) {

        if (journeyColorBackground==1){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight1 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark1 + ')'
        }
        else if (journeyColorBackground==2){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight2 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark2 + ')'
        }
        else if (journeyColorBackground==3){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight3 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark3 + ')'
        }
        else  if (journeyColorBackground==4){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight4 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark4 + ')'
        }
        else if (journeyColorBackground==5){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight5 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark5 + ')'
        }
        else if (journeyColorBackground==6){
        return 'background: linear-gradient('+ this.$vuetify.theme.themes.light.colorPalettejourneylight6 + ',' + this.$vuetify.theme.themes.light.colorPalettejourneydark6 + ')'
        }
        else
        return 'background:red'
      },

        truncateTitleMap(str, n){
  return (str.length > n) ? str.substr(0, n-1) + '...' : str;
},
    openSingleStoryDetail: function(IDOftheStoryDetail){
    //  console.info("IDOftheStoryDetail",IDOftheStoryDetail,"array",this.currentArrayOfStories.slice(this.indexArrayOfStories).concat(this.currentArrayOfStories.slice(0,this.indexArrayOfStories)))
    // list of all stories for carousel array currentArrayOfStories
    // current index of array
    this.$store.dispatch('setCurrentListOfStoriesCarousel',this.currentArrayOfStories.slice(this.indexArrayOfStories).concat(this.currentArrayOfStories.slice(0,this.indexArrayOfStories)) ).then(
      this.$store.dispatch('setSelectedSingleStoryID',parseInt(IDOftheStoryDetail)).then(
        this.$router.push({
                'name': 'carouselForSingleStoryView',query: { idStory: parseInt(IDOftheStoryDetail) }
              })
      )
      //dispatch story id in the store
)}
    },
    props: {
      isJourneyVisualization:{
        type: Boolean,
        required: false
      },
      journeyColorBackground:{
        type: Number,
        required: false
      },
      isMapIframe:{
        type: Boolean,
        required: false
      },
      isDraft:{
        type: Boolean,
        required: false
      },
      singleStory:{
        type: Object,
        required: true
      },
      currentArrayOfStories:{
        type: Array,
        required: true
      },
      indexArrayOfStories:{
        type: Number,
        required: false
      },
      isMap:{
        type: Boolean,
        required: false
      },
    },
    components:{

      mediaFileStory
    },
  computed: {
    getUser: {
      get: function () {
        return this.$store.getters.getUser;
      }
    },
    accessToken: {
      get: function () {
        return this.$store.getters.getAccessToken;
      }
    },
    currentFontSize:{
      get: function () {
          return this.$store.getters.getCurrentFontSize;
      }
    }
    },
//open single story and save data on store.
//then go to single story page

}
</script>
<style>
.titlePreviewFontStyle{
white-space: nowrap;
font-size: 1rem;
font-weight: bold;
text-overflow: ellipsis;
width: 10rem;
display: block;


}
@media only screen and (max-width: 320px) {
.titlePreviewFontStyle{
text-overflow: ellipsis;
width: 9rem;
display: block;

}
}

.authorPreviewFontStyle{
  text-transform:capitalize;
  white-space: nowrap;
  font-size: 0.8rem;
}
.is_draftPreviewfontStyle{
white-space: nowrap;
font-size: 0.8rem;

}
.datePreviewfontStyle{
white-space: nowrap;
font-size: 0.8rem;

}
</style>